import {
    EmptyRequestVerticalError,
    BadRequestVerticalError,
    LoadScriptVerticalError,
} from './dynamicLoad.error';

const Storage = require('utilities/storage');

export const addScript = (src, vertical) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.setAttribute('id', vertical.id);

        if (!document.head) return null;

        script.onload = resolve;
        script.onerror = () => reject(new LoadScriptVerticalError(`Failed loading script for vertical ${vertical.proxy}`));

        document.head.appendChild(script);
    });
};

export const getVerticalContent = async (url) => {
    let content;

    try {
        const response = await fetch(url);
        content = await response.text();
    } catch (e) {
        throw BadRequestVerticalError(e.message);
    }

    if (!content) {
        throw new EmptyRequestVerticalError(`Error source URL ${url}`);
    }

    return content;
};

export const prepareSrc = (text) => {
    const dom = new DOMParser().parseFromString(text, 'text/html');
    const baseEl = dom.createElement('base');
    baseEl.href = window.PRIVATE_WEB_MF_URL;
    dom.head.appendChild(baseEl);
    return dom.scripts[0].src;
};

export const scriptIsAlreadyLoaded = (identifier) => {
    return window.globals && window.globals[identifier] && !!document.getElementById(identifier);
};

export const buildVerticalUrl = (verticalName) => {
    // TODO: make environment dynamic
    return `${window.PRIVATE_WEB_MF_URL}/${verticalName}-${window.COUNTRY}/index.html`;
};

export const getSessionData = () => {
    const accessToken = Storage.cookies.get('accessToken');
    const refreshToken = Storage.cookies.get('refreshToken');
    const customerSessionId = Storage.cookies.get('customerSessionId');
    const username = Storage.cookies.get('username');
    return { accessToken, refreshToken, customerSessionId, username };
};
